import { Facet as FacetType, FacetValue } from "@coveo/headless";
import { useEffect, useState } from "react";

type FacetProps = {
	facet: FacetType;
	facetGroup: string;
};

const Facet = ({ facet, facetGroup }: FacetProps) => {
	const [, setState] = useState(facet.state);
	const [facetArr, setFacetArr] = useState<FacetValue[]>([]);

	useEffect(() => {
		facet.subscribe(() => {
			setState(facet.state);
		});
	}, [facet]);

	useEffect(() => {
		if (facet.state.values.length > 0) {
			let arr = [...facet.state.values];
			setFacetArr(
				arr.sort((a, b) => a.value.localeCompare(b.value, undefined, { sensitivity: "base" }))
			);
		}
	}, [facet.state.values]);

	if (facet.state.values.length === 0) {
		return <></>;
	}

	return (
		<>
			{facetArr.map((item) => (
				<button
					key={item.value}
					aria-label={item.value}
					className={
						"coveo-headless-facet t-label-xs-heavy " +
						(item.state === "selected" ? " selected" : "")
					}
					data-a="true"
					data-a-act={`Filter | ${facetGroup}`}
					data-a-cat="Coveo"
					data-a-lbl={item.value}
					onClick={() => {
						facet.toggleSelect(item);
					}}
					data-qa={`coveo-headless-facet-${item.value}`}
				>
					{item.value}
				</button>
			))}
		</>
	);
};

export default Facet;
